import styled from 'styled-components'

import { PriceStyled } from '@webapp/core/components/Price/styles/PriceStyled'

interface IBudgetCategoryCardDetailsBreakdownStyledProps {}

export const BudgetCategoryCardDetailsBreakdownStyled = styled.div<IBudgetCategoryCardDetailsBreakdownStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  padding: ${(props) => props.theme.typography.pxToRem(24)};

  ${PriceStyled} {
    display: inline;
  }
`
